import { render, staticRenderFns } from "./SettingGroup.vue?vue&type=template&id=0c067267&scoped=true&"
import script from "./SettingGroup.vue?vue&type=script&lang=js&"
export * from "./SettingGroup.vue?vue&type=script&lang=js&"
import style0 from "./SettingGroup.vue?vue&type=style&index=0&id=0c067267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c067267",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VCardText,VCheckbox})
